export enum PurchasingStatusDescription {
    Active = 1,
    ClosedOut = 2,
    Inactive = 3,
}
